import { TASK_STATUS } from "common/constants";
import { TASK_STATUS_TO_LABEL } from "common/utils/tasks";
import { Tag, TagProps } from "../Common/Tag";

const taskStatusToStyleVariant: Record<TASK_STATUS, TagProps["styleVariant"]> =
  {
    [TASK_STATUS.TO_DO]: "warning",
    [TASK_STATUS.IN_PROGRESS]: "default",
    [TASK_STATUS.COMPLETE]: "neutral",
  };

type Props = {
  status: TASK_STATUS;
} & Omit<TagProps, "styleVariant">;

export function StatusTag({ status, ...props }: Props) {
  const statusLabel = TASK_STATUS_TO_LABEL[status];
  const styleVariant = taskStatusToStyleVariant[status];

  return (
    <Tag {...props} styleVariant={styleVariant}>
      {statusLabel}
    </Tag>
  );
}
